import React from 'react'

const InovataUSDARequired = ({shipment}) => {
    
    if (!shipment) return null

    if (shipment.customerId !== "inovatafoods") return null

    // is there a shipment .customFields array with an objectwith a fieldId property with the value of 10525 and a value property with the value of "1"?
    const hasRequiredCustomField = shipment.customFields?.some(
        field => field.fieldId === 10525 && field.value === "1"
    )

    if (!hasRequiredCustomField) return null

    return (
        <div className='row mt-3'>
            <div className='col-12 text-center'>
                <div className="alert alert-warning border-warning rounded-pill d-inline-block text-center font-weight-bold" role="alert">
                    USDA Inspection Required.
                </div>
            </div>
        </div>
    )
}

export default InovataUSDARequired